///<reference path="teachers.module.ts" />
///<reference path="../employee/terminate.controller..ts"/>
///<reference path="../../components/models/meevo.model.custom.ts"/>


module Meevo.Plugins.Controls {

    class TeacherTerminateController extends Meevo.Plugins.Controls.TerminateController {

        static $inject = [
            'context',
            '$filter',
            '$mdDialog',
            '$translate',
            'employee'
        ];

        apply = () => {
            this.message = '';
            if (Meevo.Model.Guard.isNothing(this.terminatedDate)) {
                this.message = this.$translate.instant('LABEL_EMPLOYEE_TERMINATION_REQUIRED_DATE');
                return;
            } else if (moment(this.terminatedDate).isAfter(new Date())) {
                this.message = this.$translate.instant('MESSAGE_TEACHER_TERMINATION_DATE_MUST_BE_IN_PAST');
                return;
            } else if (moment(this.terminatedDate).isBefore(this.hireDate)) {
                this.message = this.$translate.instant('MESSAGE_TEACHER_TERMINATION_DATE_VALIDATION');
                return;
            }

            this.context.terminate(this.terminatedDate,
                this.doDeleteFutureWorkTime,
                this.doDeleteFutureBlockTime,
                this.selectedHomeLocation,
                this.doInactivateUserAtAllLocations);

            this.$mdDialog.hide();
        };
    }

    angular.module('meevo.plugins.teachers')
        .controller('meevo.plugins.teachers.TerminateController', TeacherTerminateController);
}